import apiClient from '../../../common/functions/api_axios_instance.function';

/**
 * Verifies if a PO number exists in admin records
 * @param {string} poNumber - PO number to verify
 * @returns {Promise} - API response containing PO details or error
 */
export const verifyPO = async (poNumber) => {
  try {
    const response = await apiClient.get(`/vendorInvoiceManagement/invoice/verify-po/${poNumber}`);
    return response.data;
  } catch (error) {
    // Return error response without throwing, so we can handle 404 specially
    if (error.response) {
      return {
        error: true,
        status: error.response.status,
        message: error.response.data?.message || error.message,
      };
    }
    throw error;
  }
};
